import { SHOW_MESSAGE, CLOSE_MESSAGE, SHOW_SUCCESS_BAR, CLOSE_SUCCESS_BAR } from './types'
import initialState from './initialState'

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SHOW_MESSAGE:
      return {
        ...state,
        isVisible: true,
        messageCategory: action.messageCategory,
        title: action.title,
        subTitle: action.subTitle
      }

    case CLOSE_MESSAGE:
      return {
        ...state,
        isVisible: false,
        messageCategory: null,
        title: null,
        subTitle: null
      }

    case SHOW_SUCCESS_BAR:
      return {
        ...state,
        successBar: { title: action.title, text: action.text }
      }

    case CLOSE_SUCCESS_BAR:
      return {
        ...state,
        successBar: null
      }

    default:
      return state
  }
}

export default reducer